import React from "react";
import {
  FooterContainer,
  FooterMessage,
  Logo,
  FooterLinks,
  FooterLink,
  LocationInfo,
} from "./FooterElements";
import logonav from "../../images/logonav.svg";
import linkedin from "../../images/linkedin.png";
import gmail from "../../images/gmail.png";
import instagram from "../../images/instagram.png";
import NewsletterForm from "./Newsletter/NewsletterForm";

const Footer = () => {
  return (
    <FooterContainer>
      <LocationInfo>
        <Logo src={logonav} alt="Logo" />
        <p>Feira de Santana, Bahia, Brazil</p>
        <p>Caixa Postal 44033087</p>
        <NewsletterForm />
      </LocationInfo>
      <FooterLinks>
        <p>Links Úteis</p>
        <FooterLink href="/">Inicio</FooterLink>
        <FooterLink href="/sobre">Sobre</FooterLink>
        <FooterLink href="/servicos">Serviços</FooterLink>
        <FooterLink href="/portfolio">Portfolio</FooterLink>
      </FooterLinks>
      <FooterMessage>
        <div>
          <FooterLink href="https://www.instagram.com/imagin8oficial/">
            <img src={instagram} alt="Instagram" width="30" height="30" />
          </FooterLink>
          <FooterLink href="mailto:imagin8oficial@gmail.com">
            <img src={gmail} alt="Gmail" width="30" height="30" />
          </FooterLink>
          <FooterLink href="https://www.linkedin.com/in/joabe-nascimento-632345211/">
            <img src={linkedin} alt="LinkedIn" width="30" height="30" />
          </FooterLink>
        </div>
        <p>Todos os direitos reservados © {new Date().getFullYear()}</p>
      </FooterMessage>
    </FooterContainer>
  );
};

export default Footer;
